import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <StyleSheetManager enableVendorPrefixes>

        <App />
      </StyleSheetManager>
      </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();

console.log(`_____________________________
Welcome to my CV Page.
Todo: Add public github repo
to give people access to the
source code. 
_____________________________`)